"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoSize = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Upload_1 = require("Common/Upload");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LogoSize;
(function (LogoSize) {
    LogoSize["Small"] = "small";
    LogoSize["Medium"] = "medium";
})(LogoSize = exports.LogoSize || (exports.LogoSize = {}));
var LogoUpload = (function (_super) {
    __extends(LogoUpload, _super);
    function LogoUpload(props) {
        var _this = _super.call(this, props) || this;
        _this.uploadId = "";
        _this.fileInput = react_1.default.createRef();
        return _this;
    }
    LogoUpload.prototype.componentWillUnmount = function () {
        if (this.disposeReaction) {
            this.disposeReaction();
        }
    };
    Object.defineProperty(LogoUpload.prototype, "uploadProgress", {
        get: function () {
            return this.props.uploadStore.getUploadProgress(this.uploadId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoUpload.prototype, "isUploading", {
        get: function () {
            return !!this.uploadProgress && this.uploadProgress.state === Upload_1.UploadState.Pending;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoUpload.prototype, "uploadUrl", {
        get: function () {
            if (this.uploadProgress != undefined && this.uploadProgress.url != undefined) {
                return this.uploadProgress.url;
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoUpload.prototype, "logoUrl", {
        get: function () {
            if (this.uploadProgress) {
                return this.uploadProgress.url || this.uploadProgress.dataUrl || "";
            }
            else if (this.props.logoSrc) {
                return this.props.logoSrc;
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    LogoUpload.prototype.onUpload = function () {
        return __awaiter(this, void 0, Promise, function () {
            var file;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.fileInput.current || !this.fileInput.current.files) {
                    return [2];
                }
                file = this.fileInput.current.files[0];
                if (!file) {
                    return [2];
                }
                this.props.onUploadStart();
                this.uploadId = this.props.uploadStore.upload(file);
                this.disposeReaction = (0, mobx_1.reaction)(function () {
                    return _this.uploadUrl;
                }, function () {
                    _this.props.onUploadComplete(_this.uploadUrl);
                    if (!!_this.disposeReaction) {
                        _this.disposeReaction();
                    }
                });
                return [2];
            });
        });
    };
    LogoUpload.prototype.render = function () {
        var _a;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("center", "logo-upload__logo", "logo-upload__logo--".concat(this.props.logoSize), (_a = {},
                _a["logo-upload__logo--empty"] = !this.logoUrl,
                _a["logo-upload__logo--non-empty"] = this.logoUrl,
                _a)), style: {
                backgroundImage: this.logoUrl && "url(".concat(this.logoUrl, ")"),
            } },
            !this.isUploading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("input", { className: "logo-upload__upload", type: "file", ref: this.fileInput, onChange: this.onUpload }),
                react_1.default.createElement("div", { className: "center logo-upload__shroud" },
                    react_1.default.createElement(icons_1.Edit, { className: "logo-upload__edit-icon" })))),
            this.getImageInner()));
    };
    LogoUpload.prototype.getImageInner = function () {
        if (this.isUploading || this.logoUrl) {
            return null;
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icons_1.Upload, { className: "logo-upload__upload-icon" }),
                react_1.default.createElement("div", { className: "logo-upload__upload-description" }, "Add logo")));
        }
    };
    var _a, _b;
    LogoUpload.defaultProps = {
        logoSize: LogoSize.Medium,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LogoUpload.prototype, "uploadId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Upload_1.IUploadProgress !== "undefined" && Upload_1.IUploadProgress) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], LogoUpload.prototype, "uploadProgress", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], LogoUpload.prototype, "isUploading", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], LogoUpload.prototype, "uploadUrl", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], LogoUpload.prototype, "logoUrl", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], LogoUpload.prototype, "onUpload", null);
    LogoUpload = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], LogoUpload);
    return LogoUpload;
}(react_1.default.Component));
exports.default = LogoUpload;
